import React, { useState } from "react";
import classes from "./Intro.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Typewriter from "typewriter-effect";
import Slider from "react-slick";
import devImg from "../../../images/Web_developer.svg";
import Mouse from "../Mouse/Mouse";
import emoji from "react-easy-emoji";
import Lottie from "react-lottie";
import animationData from "./web-developement.json";
const Intro = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const [settings1, setSettings1] = useState({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: false,
  });
  const [settings2, setSettings2] = useState({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2500,
    cssEase: "linear",
    arrows: false,
  });
  const [settings3, setSettings3] = useState({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    arrows: false,
  });
  return (
    <div className={classes.container}>
      <div className={classes.viewPage}>
        <div className={classes.imageToHide}>
          {/* <img className={classes.circleImage} src={devImg} alt="shahriar" /> */}
          <Lottie options={defaultOptions} height={350} width={350} />
        </div>
        <div className={classes.texts}>
          <p className={classes.hii}>
            {" "}
            Hi!!!<span className={classes.waveEmoji}>👋</span>
          </p>
          <p className={classes.name}>
            <small>I'm</small> Shahriar Saleh
          </p>
          {/* <p className={classes.list}>I'm a |</p> */}
          <div className={classes.typeWrite}>
            <Typewriter
              options={{
                strings: [
                  "React Developer",
                  "Front-End Developer",
                  "Programmer",
                ],
                autoStart: true,
                loop: true,
              }}
            />
          </div>
          <div className={classes.line}></div>
          <div className={classes.flexContainer}>
            <Slider {...settings1}>
              <div className={classes.slick}>React</div>
              <div className={classes.slick}>Javascript</div>
              <div className={classes.slick}>ES6</div>
              <div className={classes.slick}>HTML5</div>
              <div className={classes.slick}>CSS3</div>
            </Slider>
            <Slider {...settings2}>
              <div className={classes.slick}>NodeJs</div>
              <div className={classes.slick}>Express</div>
              <div className={classes.slick}>MongoDB</div>
              <div className={classes.slick}>Mongoose</div>
            </Slider>
            <Slider {...settings3}>
              <div className={classes.slick}>React Router</div>
              <div className={classes.slick}>Material UI</div>
              <div className={classes.slick}>chartJs</div>
              <div className={classes.slick}>Stripe.js</div>
            </Slider>
          </div>
        </div>
        <div className={classes.image}>
          {/* <img className={classes.circleImage} src={devImg} alt="shahriar" /> */}
          <Lottie options={defaultOptions} height={580} width={580} />
        </div>
      </div>
      <Mouse />
    </div>
  );
};

export default Intro;
